import React from "react";
import { LOGO_PUBLIC_CACHE_BUST } from "../config/logoSizes";
const authCssSized = (className) => /\bauth-logo-img\b/.test(className);
const bust = LOGO_PUBLIC_CACHE_BUST || "";
// Track the active theme so the full logo can swap to a dark-readable variant.
const useIsDark = () => {
  const get = () => (typeof document !== "undefined" && document.documentElement.getAttribute("data-theme") === "dark");
  const [dark, setDark] = React.useState(get);
  React.useEffect(() => {
    const el = document.documentElement;
    const obs = new MutationObserver(() => setDark(get()));
    obs.observe(el, { attributes: true, attributeFilter: ["data-theme"] });
    setDark(get());
    return () => obs.disconnect();
  }, []);
  return dark;
};
const Logo = ({ size = 6e3, className = "", style = {}, variant = "full", instanceId = "" }) => {
  const isDark = useIsDark();
  const iq = instanceId ? `&i=${encodeURIComponent(instanceId)}` : "";
  const markLight = `/logo-withoutword-light.svg${bust}${iq}`;
  const markDark = `/logo-withoutword-dark.svg${bust}${iq}`;
  // Full logo: use the dark-readable variant (light wordmark) in dark mode.
  const fullPng = `${isDark ? "/logo-dark.svg" : "/logo.svg"}${bust}${iq}`;
  const fullLight = `/logo-light.svg${bust}${iq}`;
  const src = variant === "mark" ? markLight : fullPng;
  const themeClass = "logo-light-clean";
  const skipFixedWidth = variant === "full" && authCssSized(className);
  if (variant === "mark") {
    return <img
      src={src}
      alt="TaaweelAI"
      className={`${className} ${themeClass}`.trim()}
      style={{
        objectFit: "contain",
        ...(skipFixedWidth ? {} : { width: size, height: size }),
        maxWidth: "100%",
        ...style
      }}
      draggable={false}
      onError={(e) => {
        const el = e.currentTarget;
        if (el.src.includes("logo-withoutword-light")) {
          el.src = markDark;
        } else if (el.src.includes("logo-withoutword-dark")) {
          el.onerror = null;
        }
      }}
    />;
  }
  return <img
    src={src}
    alt="TaaweelAI"
    className={`${className} ${themeClass}`.trim()}
    style={{
      objectFit: "contain",
      ...(skipFixedWidth ? {} : { width: size }),
      height: "auto",
      maxWidth: "100%",
      display: "block",
      ...style
    }}
    draggable={false}
    onError={(e) => {
      const el = e.currentTarget;
      if (el.src.includes("/logo.svg")) el.src = fullLight;
    }}
  />;
};
var stdin_default = Logo;
export {
  stdin_default as default
};
